module.exports = __webpack_public_path__ + "img/4.e246ec9e.png";